import { Descriptions } from "@/components/v2";
import { Button, Card } from "@rumbledirect/ui";
import { Popconfirm, Space, type DescriptionsProps } from "antd";
import type { ImageCapturePage } from "@rumble-it/common-lib/types/models/ImageCapture.interface";
import type { UseMutationResult } from "@tanstack/react-query";
import { Link } from "react-router-dom";

interface ImageCapturePageDetailCardProps {
  page: ImageCapturePage | null | undefined;
  isLoading: boolean;
  deleteMutation?: UseMutationResult<null, Error, void, unknown>;
}

export const ImageCapturePageDetailCard = ({
  page,
  isLoading,
  deleteMutation,
}: ImageCapturePageDetailCardProps) => {
  const { settings } = page || {};
  const { isImageRequired, ...otherSettings } = settings || {};

  const items: DescriptionsProps["items"] = [
    { label: "Titel", children: page?.title ?? null },
    { label: "Type", children: page?.type?.value ?? page?.type?.name ?? null },
    { label: "Volgorde", children: page?.priority ?? null },
    {
      label: "Afbeelding verplicht",
      children:
        typeof isImageRequired === "boolean"
          ? isImageRequired
            ? "Ja"
            : "Nee"
          : null,
    },
    otherSettings && Object.keys(otherSettings).length > 0
      ? {
          label: "Andere instellingen",
          children: (
            <pre className="whitespace-pre-wrap">
              {JSON.stringify(otherSettings, null, 2)}
            </pre>
          ),
        }
      : null,
  ];

  return (
    <Card
      loading={isLoading}
      title={`ImageCapture Pagina: ${page?.title ?? "Pagina"}`}
      extra={
        <Space>
          <Link to={`${page?.id}/edit`}>
            <Button>Bewerken</Button>
          </Link>
          <Popconfirm
            title="Pagina verwijderen"
            description="Weet je zeker dat je deze pagina wilt verwijderen?"
            onConfirm={() => deleteMutation?.mutate()}
            okText="Ja"
            cancelText="Nee"
          >
            <Button loading={deleteMutation?.isPending} danger>
              Verwijderen
            </Button>
          </Popconfirm>
        </Space>
      }
    >
      <Descriptions items={items} />
    </Card>
  );
};
